<template>
  <div class="interface">
    <div class="interface__menu">
      <InterfaceButtons v-for="(item, index) in buttons" :key="index" :item="item" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import InterfaceButtons from 'components/setting/interface/InterfaceButtons'
export default {
  name: 'Interface',
  props: ['buttons'],
  components: {
    InterfaceButtons,
  },
  data() {
    return {
      menu: false,
      page: 1,
      limit: 10,
      projectList: null,
      selectedItem: 1,
    }
  },
  computed: {
    ...mapGetters('workDocsWorkArea', ['workDocsWorkAreaGrid_project']),
    ...mapGetters('workClientProject', [
      'workClientProjectGrid',
      'workClientProjectShow',
      'pageData',
    ]),
    ...mapGetters(['loadingAnimation']),
  },
  methods: {
    ...mapActions('workDocsWorkArea', ['onWorkDocsWorkAreaGrid_project']),
    ...mapActions('workClientProject', ['onWorkClientProjectGrid', 'onWorkClientProjectShow']),
  },
  watch: {},
}
</script>

<style lang="scss" scoped>
.interface {
  &__menu {
    max-width: 400px;
    width: 100%;
    box-shadow: 0px 30px 30px rgba(39, 127, 175, 0.2);

    &--children {
      visibility: hidden;
      position: absolute;
      top: 0;
      left: 100%;
      background-color: #ffffff;
      filter: drop-shadow(4px 4px 4px rgba(37, 120, 173, 0.2));
      transition: 0.3s;
    }
  }
}
</style>
